// import React, { useState, useEffect } from "react";
// import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// import { Button } from "@mui/material";

// const AppointmentCardPaymentBill = ({ patientData, amount, onSuccess }) => {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [clientSecret, setClientSecret] = useState("");
//   const [customerId, setCustomerId] = useState("");
//   const [disablebutton, setdisablebutton] = useState(false);
//   const [loading, setloading] = useState(false);
//   const [errorMessage, seterrorMessage] = useState(null);
//   useEffect(() => {
//     fetch(
//       `https://medispacosmos.com/riteclinic-openemr/apis/default/api/customer`,
//       {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           email: patientData.patient_email,
//           firstName: patientData.patient_fname,
//           lastName: patientData.patient_lname,
//         }),
//       }
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         setCustomerId(data.customerId);

//         return fetch(
//           `https://medispacosmos.com/riteclinic-openemr/apis/default/api/paymentintent`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({
//               amount: parseFloat(amount),
//               email: patientData.patient_email,
//               firstName: patientData.patient_fname,
//               lastName: patientData.patient_lname,
//               customerId: data.id,
//             }),
//           }
//         );
//       })
//       .then((res) => res.json())
//       .then((data) => {
//         setClientSecret(data.client_secret);
//       });
//   }, [amount]);

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     if (!stripe || !elements) {
//       return;
//     }
//     setloading(true);
//     const result = await stripe.confirmCardPayment(clientSecret, {
//       payment_method: {
//         card: elements.getElement(CardElement),
//       },
//     });

//     if (result.error) {
//       setloading(false);
//       console.log("Payment Error!", result.error);
//       seterrorMessage(result.error.message);
//       console.log(result.error.message);
//     } else if (result.paymentIntent.status === "succeeded") {
//       setloading(false);
//       console.log("Payment succeeded!");
//       if (typeof onSuccess === "function") {
//         onSuccess();
//         console.log("onSuccess Called!");

//       }
//     }
//   };

//   return (
//     <div>
//       <form onSubmit={handleSubmit}>
//         <div
//           style={{
//             padding: "15px",
//             border: "1px solid #ccc",
//             borderRadius: "4px",
//             maxWidth: "100%",
//             margin: "auto",
//           }}
//         >
//           <label
//             style={{ fontSize: "16px", marginBottom: "8px", display: "block" }}
//           >
//             {/* Card details: */}
//             <CardElement
//               options={{
//                 style: {
//                   base: {
//                     fontSize: "16px",
//                     color: "#424770",
//                     "::placeholder": {
//                       color: "#aab7c4",
//                     },
//                   },
//                   invalid: {
//                     color: "#9e2146",
//                   },
//                 },
//               }}
//             />
//           </label>
//           <div style={{ textAlign: "center", paddingTop: "10px" }}>
//             <Button
//               variant="success"
//               type="submit"
//               disabled={!stripe || disablebutton}
//             >
//               Pay $ {amount}
//             </Button>
//           </div>
//           {errorMessage && (
//             <div style={{ textAlign: "justify", paddingTop: "10px" }}>
//               <p style={{ color: "red" }}>{errorMessage && errorMessage}</p>
//             </div>
//           )}
//         </div>
//       </form>
//     </div>
//   );
// };

// export default AppointmentCardPaymentBill;


import React, { useState, useEffect } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Button } from "@mui/material";

const AppointmentCardPaymentBill = ({ patientData, amount, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [clientSecret, setClientSecret] = useState("");
  const [disablebutton, setdisablebutton] = useState(false);
  const [loading, setloading] = useState(false);
  const [errorMessage, seterrorMessage] = useState(null);

  // Fallback logic for email, fname, lname
  const email = patientData?.patient_email || patientData?.email || "";
  const firstName = patientData?.patient_fname || patientData?.fname || "";
  const lastName = patientData?.patient_lname || patientData?.lname || "";

  useEffect(() => {
    if (!email || !firstName || !lastName) return;

    fetch(`https://medispacosmos.com/riteclinic-openemr/apis/default/api/customer`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, firstName, lastName }),
    })
      .then((res) => res.json())
      .then((data) => {
        return fetch(`https://medispacosmos.com/riteclinic-openemr/apis/default/api/paymentintent`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            amount: parseFloat(amount),
            email,
            firstName,
            lastName,
            customerId: data.id,
          }),
        });
      })
      .then((res) => res.json())
      .then((data) => {
        setClientSecret(data.client_secret);
      })
      .catch((err) => {
        console.error("Error initializing payment:", err);
        seterrorMessage("Failed to initialize payment. Please try again.");
      });
  }, [amount, email, firstName, lastName]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) return;

    setloading(true);

    const result = await stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: elements.getElement(CardElement),
      },
    });

    if (result.error) {
      setloading(false);
      seterrorMessage(result.error.message);
    } else if (result.paymentIntent.status === "succeeded") {
      setloading(false);
      if (typeof onSuccess === "function") {
        onSuccess();
      }
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div
          style={{
            padding: "15px",
            border: "1px solid #ccc",
            borderRadius: "4px",
            maxWidth: "100%",
            margin: "auto",
          }}
        >
          <label
            style={{ fontSize: "16px", marginBottom: "8px", display: "block" }}
          >
            <CardElement
              options={{
                style: {
                  base: {
                    fontSize: "16px",
                    color: "#424770",
                    "::placeholder": {
                      color: "#aab7c4",
                    },
                  },
                  invalid: {
                    color: "#9e2146",
                  },
                },
              }}
            />
          </label>
          <div style={{ textAlign: "center", paddingTop: "10px" }}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={!stripe || disablebutton || loading}
            >
              {loading ? "Processing..." : `Pay $${amount}`}
            </Button>
          </div>
          {errorMessage && (
            <div style={{ textAlign: "justify", paddingTop: "10px" }}>
              <p style={{ color: "red" }}>{errorMessage}</p>
            </div>
          )}
        </div>
      </form>
    </div>
  );
};

export default AppointmentCardPaymentBill;
